export const ORDER_NOTIFICATION_EDITOR_ROLES = [
  'BUYER',
  'SELLER',
  'TRADER',
] as const;

export function canEditOrderNotifications(
  role: string | null | undefined
): boolean {
  return (ORDER_NOTIFICATION_EDITOR_ROLES as readonly string[]).includes(
    role ?? ''
  );
}
